import * as t from 'io-ts';
export var Response = t.type({
  questionId: t.string,
  radioResponse: t.string
});
export var SubmitQuizInput = t.type({
  stageId: t.string,
  responses: t.array(Response)
});
export var ResponseResult = t.type({
  correctAnswer: t.string,
  questionId: t.string,
  pointsEarned: t.number
});
export var SubmitQuizResponse = t.type({
  __typename: t.literal('SubmitQuizResult'),
  pointsEarned: t.number,
  correctQuestions: t.number,
  responseResults: t.array(ResponseResult)
});
export var SubmitQuizResult = t.type({
  submitQuiz: t.union([SubmitQuizResponse, t.type({
    __typename: t.literal('SubmitQuizErrorType'),
    errors: t.array(t.type({
      message: t.string
    }))
  })])
});